import { Injectable } from "@angular/core";
import { DynamicField } from "../interfaces/dynamic-form-model";
import { FormGroup } from "@angular/forms";
import { RuleEngineService } from "./rule-engine.service";
import { ColumnMeta } from "../models/dosing.model";

@Injectable({ providedIn: 'root' })
export class DynamicFormRuleApplierService {

    constructor(private ruleEngine: RuleEngineService) { }

    applyRulesForForm(
        fields: DynamicField[],
        form: FormGroup
    ): Record<string, any> {

        const formValue = form.getRawValue();

        return fields.reduce((uiState, field: DynamicField) => {
            const fieldState = this.ruleEngine.evaluate(field, formValue);

            // if ('readonly' in field)
            //     field.readonly = fieldState.readonly;
            // if ('required' in field)
            //     field.required = fieldState.required;
            // if ('visible' in field)
            //     field.visible = fieldState.visible;

            // Sync with FormControl
            const control = form.get(field.key);
            if (control) {
                fieldState.readonly
                    ? control.disable({ emitEvent: false })
                    : control.enable({ emitEvent: false });
            }

            uiState[field.key] = fieldState;
            return uiState;
        }, {} as Record<string, any>);
    }


    applyRulesForRecords(
        fields: DynamicField[],
        apiResponse: any
    ): ColumnMeta[] {
        return fields.reduce((acc: ColumnMeta[], field: DynamicField) => {
            const fieldState = this.ruleEngine.evaluate(field, apiResponse);
            if (fieldState.visible) {
                acc.push({
                    key: field.key,
                    header: fieldState.label,
                    type: field.type,
                    order: field.order,
                });
            }

            return acc; // always return the accumulator
        }, []);
    }

    applyRulesForUpsertForm(
        fields: DynamicField[],
        apiResponse: any
    ): Record<string, any> {
        return fields.reduce((uiState, field: DynamicField) => {
            const fieldState = this.ruleEngine.evaluate(field, apiResponse);
            uiState[field.key] = fieldState;
            return uiState;
        }, {} as Record<string, any>);
    }
}
